import React, { useState } from "react";
import { Code2, Copy, Check, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

export default function EmbedSnippet() {
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState(false);
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const snippet = `<iframe
  src="${origin}/embed"
  width="100%"
  height="640"
  style="border:1px solid #E5E2DC; border-radius:16px;"
  loading="lazy"
  title="Centennial — free retirement calculator"
></iframe>`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for restricted-context iframes / older browsers
      setCopyError(true);
      setTimeout(() => setCopyError(false), 3000);
    }
  };

  return (
    <section data-testid="embed-snippet" className="py-20 lg:py-28 bg-white border-y border-[#E5E2DC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold">
            for blogs & advisors
          </div>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl tracking-tight font-medium text-[#1C2B23]">
            Embed Centennial anywhere.
          </h2>
          <p className="mt-5 text-[#5C6B62] leading-relaxed max-w-xl">
            Drop a single iframe into your blog post, advisor site, or course — and give your readers a
            real Monte Carlo retirement calculator running on live market data, completely free.
          </p>
          <Link
            data-testid="open-embed-preview"
            to="/embed"
            target="_blank"
            className="mt-7 inline-flex items-center gap-2 text-sm text-[#2B5339] underline-offset-4 hover:underline"
          >
            Open standalone widget <ExternalLink size={14} />
          </Link>
        </div>
        <div className="lg:col-span-7">
          <div className="rounded-2xl bg-[#1C2B23] text-[#D6DBD7] font-mono text-[12px] leading-relaxed p-6 relative overflow-hidden">
            <div className="absolute top-3 right-3 flex items-center gap-2">
              <Code2 size={12} className="text-[#728A7C]" />
              <span className="text-[10px] tracking-[0.18em] uppercase text-[#728A7C]">html</span>
              <button
                data-testid="copy-embed"
                onClick={copy}
                className="ml-2 inline-flex items-center gap-1 text-[10px] tracking-[0.16em] uppercase bg-[#2B5339] hover:bg-[#348C59] text-white rounded-full px-2.5 py-1 transition-colors"
              >
                {copied ? <Check size={11} /> : <Copy size={11} />}
                {copied ? "copied" : copyError ? "select all → copy" : "copy"}
              </button>
            </div>
            <pre className="whitespace-pre-wrap">{snippet}</pre>
          </div>
        </div>
      </div>
    </section>
  );
}
